import { Page } from "components/Page";
import DateWiseReport from "../components/common/HistoryReport";
import { GridColDef } from "@mui/x-data-grid";

const customerColumns: GridColDef[] = [
  { headerName: "Name", field: "name", flex: 2 },
  { headerName: "Main Aadhaar", field: "mainAadhaar", flex: 1 },
  { headerName: "Family Aadhaar", field: "familyAadhaar", flex: 1 },
  { headerName: "Mobile", field: "mobile", flex: 1 },
  { headerName: "Consumer No", field: "consumerNo", flex: 1 },
  { headerName: "Main Agent", field: "mainAgent", flex: 2 },
  {
    headerName: "Registerd Agency Name",
    field: "registeredAgencyName",
    flex: 2,
  },
  { headerName: "Remarks", field: "remarks", flex: 3 },
  { headerName: "Added By", field: "addedBy", flex: 1 },
  { headerName: "Installation Status", field: "installtatus", flex: 1 },
];

const cashMemoColumns: GridColDef[] = [
  { headerName: 'CDCMS Punch', field: 'cdcmsCashMemoPunch', flex: 1 },
  { headerName: 'Vitaran Punch', field: 'vitaranCashMemoPunch', flex: 1 },
  { headerName: 'Total Punch', field: 'totalCashMemoPunch', flex: 1 },
  { headerName: 'Remaining', field: 'remainingCashMemo', flex: 1 },
];

const refillSaleColumns: GridColDef[] = [
  { headerName: 'Record Date', field: 'recordDate', flex: 1, type: 'date' },
  { headerName: 'Driver Name', field: 'dname', flex: 1 },
  { headerName: 'Agent Name', field: 'agent', flex: 1 },
  { headerName: 'Refil Qnty', field: 'quantity', flex: 1 },
  { headerName: 'Rate', field: 'rate', flex: 1 },
  { headerName: 'Total Amount', field: 'totalAmt', flex: 1 },
  { headerName: 'Due Amount', field: 'dueAmt', flex: 1 },
  { headerName: 'Final Amount', field: 'finalAmount', flex: 1 },
];

const invoiceColumns: GridColDef[] = [
  { headerName: "Invoice No", field: "invoiceNo", flex: 1 },
  { headerName: "Date", field: "invoiceDate", flex: 1, type: "date" },
  { headerName: "Driver Name", field: "driverName", flex: 1 },
  { headerName: "Status", field: "status", flex: 1 },
];

const services = [
  {
    name: "New Customer Registrations",
    endpoint: "customer/getCustomerStats",
    columns: customerColumns,
    serviceName: "customers",
  },
  {
    name: "Last Updated Consumers",
    endpoint: "customer/lastupdatedRecords",
    columns: customerColumns,
    serviceName: "customers",
  },
  {
    name: "Cash Memos",
    endpoint: "customer/getCustomerStats",
    columns: cashMemoColumns,
    serviceName: "cashmemos",
  },
  {
    name: "Refill Sales",
    endpoint: "customer/getCustomerStats",
    columns: refillSaleColumns,
    serviceName: "refilsales",
  },
  {
    name: "Invoices",
    endpoint: "customer/getCustomerStats",
    columns: invoiceColumns,
    serviceName: "invoices",
  },
];

export const DateWiseReportPage = () => {
  return (
    <Page title="Date Wise Reports">
      <DateWiseReport title="Date Wise Reports" services={services} />
    </Page>
  );
};
